import {useAppSelector} from "./store";
import {MyMoney} from "../api-client";

export const useMyMoneyData = () => {
  return useAppSelector<MyMoney>((state) => state.myMoney);
};